// extracted by mini-css-extract-plugin
module.exports = {"swapButtonContainer":"ScatterPlot_swapButtonContainer__3YxbS","swapButton":"ScatterPlot_swapButton__tIoJD"};